// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sPuaOx1K7UiCKJrwPqdt{cursor:pointer;border-radius:4px;width:100%;height:auto;margin:0 auto}.OedTSYffSEs81eEYrS8I{max-width:312px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"img": `sPuaOx1K7UiCKJrwPqdt`,
	"withPreviews": `OedTSYffSEs81eEYrS8I`
};
export default ___CSS_LOADER_EXPORT___;
